export default __webpack_public_path__ + "static/media/AGM2023.79b897f8.png";